<wms-dialog-header title="{{ locale.LABEL_PUBLISH_PREFAB_TO_PROJECT }}"
    (onClose)="closeDialogWithId('publish-to-project')">
</wms-dialog-header>
<wms-dialog-body>
    <div>
        <wms-message *ngIf="showErrorMessage" [scopeDataset]="message"></wms-message>
        <p>
            {{ locale.MESSAGE_INFO_PUBLISH_PREFAB_PROJECT }}
        </p>
        <div>
            <div class="float-right" name="wm-projects-filter" model="projectSearch"
                title="{{ locale.LABEL_SEARCH_TITLE }}">
                <wms-search (onSearch)="filterServices($event.searchKey)"
                    placeholder="{{locale.LABEL_SEARCH}}"></wms-search>
            </div>
        </div>
        <table class="wm-table">
            <colgroup>
                <col width="50">
                <col width="50">
                <col width="300">
                <col>
            </colgroup>
            <thead>
                <tr>
                    <th></th>
                    <th></th>
                    <th>{{ locale["LABEL_PROJECT_NAME"] }}</th>
                    <th>{{ locale["LABEL_PROJECT_DESCRIPTION"] }}</th>
                </tr>
            </thead>
        </table>
        <div class="projects-list-table pb-1">
            <table class="wm-table">
                <colgroup>
                    <col width="50">
                    <col width="50">
                    <col width="300">
                    <col>
                </colgroup>
                <tbody>
                    <tr *ngFor="let project of prefabPublishService.prefabToProjectList"
                        (click)="assignSelectedProject(project)"
                        [ngClass]="{'active': selectedValue?.studioProjectId  === (project.studioProjectId || project.id)}">
                        <td class="center">
                            <input type="radio" (change)="onRadioChange()" name="selectedItem"
                                [(ngModel)]="prefabPublishService.selectedProject" [value]="project.projectId" />
                        </td>
                        <td class="center">
                            <img class="project-image" name="wm-project-avatar"
                                [src]="projectAvatarPath + project.icon" />
                        </td>
                        <td>
                            <span>{{ project.displayName || project.name }}
                                {{ "(" + project.vcsBranch + ")" }}
                            </span>
                        </td>
                        <td>
                            <p>{{ project.description }}</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="app-composite col-xs-8">
            <label class="app-label control-label col-xs-2 ">{{locale.LABEL_SELECTED_PROJECT}}</label>
            <div class="col-xs-9" *ngIf="selectedValue">
                <label class="app-label">
                    {{ selectedValue.displayName || selectedValue.name }}
                    {{ "(" + selectedValue.vcsBranch + ")" }}
                </label>
            </div>
        </div>
    </div>
</wms-dialog-body>
<wms-dialog-footer>
    <button class="cancel-action btn app-button btn-secondary" (click)="closeDialogWithId('publish-to-project')">
        <span class="btn-caption">{{ locale.LABEL_CANCEL }}</span>
    </button>
    <button class="btn-primary ok-action btn app-button" (click)="publishPrefabToProject()"
        [disabled]="!prefabPublishService.selectedProject">
        <span class="btn-caption">{{ locale.LABEL_UPDATE }}</span>
    </button>
</wms-dialog-footer>
